/**
 * @fileoverview GET handler for the "/engagement/changelogs" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementChangelogs } from "./constants";
import type { ChangelogsResult, ChangelogType } from "./types";

/**
 * @note this does not do the fine-grained typing of the individual changelog types. In a
 *   future iteration, the changelogs should probably be sliced up by `type`, e.g.
 *   `/engagement/canvas/changelog`. The individual ApiQuery hooks are responsible for
 *   yielding the properly-typed changelog objects.
 */
export const getChangelogs = reactQueryFetcherAdapter(
  engagementChangelogs,
  (signal: AbortSignal, id: string, type: ChangelogType): Promise<ChangelogsResult> => {
    return fetch("/engagement/changelogs", "GET", { id, type }, { signal });
  }
);
